import { useMediaQuery } from "@uidotdev/usehooks";

/**
 * Whether there is room for a pane beside a list, at the same width the app frame swaps the
 * floating bar for the rail. Decided in script rather than CSS so what opens is rendered once.
 */
export const useIsWide = () => useMediaQuery("only screen and (min-width: 1024px)");
